import script from "./PhotosField.vue?vue&type=script&setup=true&lang=js"
export * from "./PhotosField.vue?vue&type=script&setup=true&lang=js"

import "./PhotosField.vue?vue&type=style&index=0&id=49dac588&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49dac588"]])

export default __exports__